import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Loader from "components/loader/Loader";

const Spinner = ({ ...props }) => {
  const style = {
    // color: "#2555EF",
    width: "300px",
    height: "300px",
    position: "absolute",
    right: "40%",
    top: "50%",
  };
  return (
    //  <CircularProgress style={props.styles ? props.styles : style} />
    // <img src={Loader} style={props.styles ? props.styles : style} />
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <Loader />
    </div>
  );
};

export default Spinner;
